/**
 * @file Slice for managing the state of new asset insertions
 */

import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AssetType } from "@/assets/asset-labels";

export type Coordinates = [number, number]; // TODO Define this elsewhere

interface NewAssetState {
  coordinates: Coordinates[];
  numCoords: number;
  assetType: AssetType | null;
}

const initialState: NewAssetState = {
  coordinates: [],
  numCoords: 0,
  assetType: null,
};

export const newAsset = createSlice({
  name: "newAsset",
  initialState,
  reducers: {
    setCoordinates: (state, { payload }: PayloadAction<Coordinates[]>) => {
      state.coordinates = payload;
      state.numCoords = payload.length;
    },
    setAssetType(
      state,
      { payload }: PayloadAction<NewAssetState["assetType"]>,
    ) {
      state.assetType = payload;
    },
    clearCoordinates: (state) => {
      state.coordinates = [];
      state.numCoords = 0;
    },
  },
});

export default newAsset.reducer;
export const { setCoordinates, setAssetType, clearCoordinates } =
  newAsset.actions;
